import React, { Component } from 'react';
import { connect } from 'dva';
import { Icon, Modal } from 'antd';
import SelectUser from 'nbugs-address-select-user';
import styles from './index.less';

const { confirm } = Modal;

@connect(({ roleManagement }) => ({
  ...roleManagement,
}))
class RoleList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  removeUser = (data, user) => {
    const { dispatch, currentselectTreeNode } = this.props;
    confirm({
      okText: '确认',
      cancelText: '取消',
      title: '删除岗位设置',
      content: `确定删除“${user.userName}”岗位设置？`,
      onOk: () => {
        dispatch({
          type: 'roleManagement/removeUser',
          params: {
            deptId: currentselectTreeNode.deptId,
            roleSign: data.roleSign,
            userId: user.userId,
          },
          currentselectTreeNode,
        });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  setRole = data => {
    let { userList = [] } = data;
    const { dispatch } = this.props;
    if (userList == null) {
      userList = [];
    }
    userList.forEach(user => {
      user.type = 'user';
    });
    dispatch({
      type: 'roleManagement/save',
      payload: {
        currentRoleList: data,
        checkedNodes: userList,
        showSelectUserModal: true,
      },
    });
  };

  handleConfirm = ({ checkedNodes = [] } = {}) => {
    const { currentRoleList, dispatch, currentselectTreeNode } = this.props;
    const userIds = [];
    const userList = checkedNodes.filter(item => item.type === 'user');
    userList.forEach(user => {
      userIds.push(user.userId);
    });
    dispatch({
      type: 'roleManagement/addRoleUser',
      params: {
        deptId: currentselectTreeNode.deptId,
        roleSign: currentRoleList.roleSign,
        userIds,
      },
      currentselectTreeNode,
    });
  };

  handleCancel() {
    const { dispatch } = this.props;
    dispatch({
      type: 'roleManagement/save',
      payload: {
        checkedNodes: [],
        showSelectUserModal: false,
      },
    });
  }

  render() {
    const { deptRoleList } = this.props;
    const { checkedNodes, showSelectUserModal } = this.props;
    return (
      <div className={styles.deptRoleListWrap}>
        {deptRoleList.length > 0 ? (
          <div className="deptRoleList">
            {deptRoleList.map(item => {
              return (
                <div className="listItem">
                  <div className="roleName">{item.roleName}</div>
                  <div className="userList">
                    {item.userList
                      ? item.userList.map(user => {
                          return (
                            <div className="userItem">
                              {user.userName ? user.userName : ''}{' '}
                              <span onClick={() => this.removeUser(item, user)}>
                                <Icon type="close" />
                              </span>
                            </div>
                          );
                        })
                      : null}
                    <div className="option" onClick={() => this.setRole(item)}>
                      {item.userList && item.userList.length > 0 ? '添加' : '设置'}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="noRole">
            <img src="https://s.xiaoyuanhao.com/nbugs/address/images/noRole.png" alt="" />
            <p>本部门无需设置的岗位</p>
          </div>
        )}
        {showSelectUserModal && (
          <SelectUser
            loopStyle="entire"
            selectType="user"
            showSearchInput={false}
            showComp={showSelectUserModal}
            checkedNodes={checkedNodes}
            onCancel={this.handleCancel}
            onOk={this.handleConfirm}
            deptNodeCheckable={false}
          />
        )}
      </div>
    );
  }
}

export default RoleList;
